import SubcategoryPage from '@/components/template/SubcategoryPage';

const KovinskiDodatki = () => {
  const products = [
    {
      title: "Medeninasti svečniki Oro",
      imageSrc: "https://images.unsplash.com/photo-1599638075338-c400e736d58b?auto=format&fit=crop&q=80",
      url: "/dodatki/kovinski/oro"
    },
    {
      title: "Kovinska dekorativna skleda Metallo",
      imageSrc: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?auto=format&fit=crop&q=80",
      url: "/dodatki/kovinski/metallo"
    },
    {
      title: "Kovinski podstavki Ferro",
      imageSrc: "https://images.unsplash.com/photo-1516981879613-9f5da904015f?auto=format&fit=crop&q=80",
      url: "/dodatki/kovinski/ferro"
    },
    {
      title: "Kovinske okrasne figure Scultura",
      imageSrc: "https://images.unsplash.com/photo-1598106755735-3861ab078aec?auto=format&fit=crop&q=80",
      url: "/dodatki/kovinski/scultura"
    }
  ];

  return (
    <SubcategoryPage
      title="Kovinski dodatki"
      description="Elegantni kovinski dodatki, ki s svojim sijočim ali matiranim videzom dodajo industrijski ali luksuzni pridih vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1599638075338-c400e736d58b?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default KovinskiDodatki;